import { render, staticRenderFns } from "./AlimentaryRecord.vue?vue&type=template&id=59d583fb&scoped=true"
import script from "./AlimentaryRecord.vue?vue&type=script&lang=ts"
export * from "./AlimentaryRecord.vue?vue&type=script&lang=ts"
import style0 from "./AlimentaryRecord.vue?vue&type=style&index=0&id=59d583fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d583fb",
  null
  
)

export default component.exports
import {QToolbar,QBtn,QToolbarTitle,QImg,QFooter} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QBtn,QToolbarTitle,QImg,QFooter})
